<template>
  <div>
    <section class="content">
      <h2>数据统计</h2>
      <ul v-if="details != ''" class="infoStyle">
        <li>
          <label>姓名：</label>
          <p>{{ detail.user_name }}</p>
        </li>
        <li>
          <label>身份类型：</label>
          <p v-if="detail.employee_type == 1">内部员工</p>
          <p v-else-if="detail.employee_type == 2">三方员工</p>
        </li>
        <li>
          <label>简历总数：</label>
          <p>{{ detail.total_resume }}</p>
        </li>
        <li>
          <label>新简历数：</label>
          <p>{{ detail.total_new_resume }}</p>
        </li>
        <li>
          <label>沟通数：</label>
          <p>{{ detail.total_communicate }}</p>
        </li>
        <li>
          <label>指派任务数：</label>
          <p>{{ detail.total_assign }}</p>
        </li>
        <li>
          <label>指派任务处理数：</label>
          <p>{{ detail.total_assign_end }}</p>
        </li>
        <li>
          <label>面试简历数：</label>
          <p>{{ detail.total_interview }}</p>
        </li>
        <li>
          <label>到面的简历数：</label>
          <p>{{ detail.total_interview_success }}</p>
        </li>
        <li>
          <label>到面率：</label>
          <p>{{ detail.interview_rate }}</p>
        </li>
        <li>
          <label>总入职数：</label>
          <p>{{ detail.total_entry }}</p>
        </li>
        <li>
          <label>在职数：</label>
          <p>{{ detail.total_entry_on }}</p>
        </li>
        <li>
          <label>在职率：</label>
          <p>{{ detail.entry_on_rate }}</p>
        </li>
        <li>
          <label>离职数：</label>
          <p>{{ detail.total_leave }}</p>
        </li>
        <li>
          <label>离职率：</label>
          <p>{{ detail.leave_rate }}</p>
        </li>
        <li>
          <label>总入职数：</label>
          <p>{{ detail.count_entry }}</p>
        </li>
      </ul>
    </section>
    <section class="content">
      <h2>表格统计</h2>

      <table>
        <thead>
          <th>面访总数</th>
          <th>新员工</th>
          <th>老员工</th>
          <th>甲方客户</th>
        </thead>
        <tbody>
          <tr>
            <td>{{ detail.all_view }}</td>
            <td>{{ detail.interview_view_count }}</td>
            <td>{{ detail.interview_visit_view_count }}</td>
            <td>{{ detail.interview_customer_visit_view_count }}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead>
          <th>电话and社交APP总数</th>
          <th>新员工</th>
          <th>老员工</th>
          <th>甲方客户</th>
        </thead>
        <tbody>
          <tr>
            <td>{{ detail.and_all_view }}</td>
            <td>{{ detail.and_interview_view_count }}</td>
            <td>{{ detail.and_visit_view_count }}</td>
            <td>{{ detail.and_customer_visit_view_count }}</td>
          </tr>
        </tbody>
      </table>
      <table v-if="detail.entry_project_list != ''">
        <thead>
          <th>项目</th>
          <th>入职人数</th>
        </thead>
        <tbody>
          <tr v-for="(item, k) in detail.entry_project_list" :key="k">
            <td>{{ item.project_name }}</td>
            <td>{{ item.entry_num }}</td>
          </tr>
        </tbody>
      </table>
      <table v-if="detail.leave_project_list != ''">
        <thead>
          <th>项目</th>
          <th>离职人数</th>
        </thead>
        <tbody>
          <tr v-for="(item, k) in detail.leave_project_list" :key="k">
            <td>{{ item.project_name }}</td>
            <td>{{ item.count_leave }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  props: {
    details: {}
  },
  watch: {
    details() {
      this.detail = this.details;
      console.log(this.detail);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 4% 0;
  .infoStyle {
    > li {
      display: inline-block;
      width: 33.3%;
    }
  }
  h2 {
    font-weight: normal;
    line-height: 24px;
    margin-bottom: 20px;
  }
  > ul {
    > li {
      margin-top: 10px;
      p,
      label {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
  table {
    display: inline-block;
    width: 50%;
    vertical-align: top;
    margin-bottom: 30px;
    td,
    th {
      border: 1px solid #ccc;
      font-size: 14px;
      padding: 4px 10px;
    }
  }
}
</style>
